// extracted by mini-css-extract-plugin
export default {"section":"Outcomes_section__6R-8y","grid":"Outcomes_grid__YnR2W","card":"Outcomes_card__p0SBl","icon":"Outcomes_icon__KfiZx","label":"Outcomes_label__FigXr"};